export default function PokeNotFound(){
    return <div>Prueba Not Found</div>;
}